// Types
import type { TApiHttpClientRequestConfig } from '~/misc/resource/types';
import type {
  TUser,
  TNewUser,
  TPaginatedUsers,
  TUserIndexPayload,
} from '~/misc/user-resource/types';
import type { TLoginLink } from '~/modules/manager/company/users/types';
import { ESubscriptionType } from '~/modules/manager/types';

// Models
import { ManagerResource } from '~/modules/manager/resource/manager-resource.model';

export class ManagerUserModel extends ManagerResource {
  index(
    companyId: number,
    payload: TUserIndexPayload,
    requestConfig?: TApiHttpClientRequestConfig
  ): Promise<TPaginatedUsers> {
    return this.get<TPaginatedUsers>(`companies/${companyId}/users`, payload, requestConfig);
  }

  show(id: number, requestConfig?: TApiHttpClientRequestConfig): Promise<TUser> {
    return this.get<TUser>(`users/${id}`, undefined, requestConfig);
  }

  store(
    companyId: number,
    payload: TNewUser,
    requestConfig?: TApiHttpClientRequestConfig
  ): Promise<TUser> {
    return this.post<TUser>(`companies/${companyId}/users`, payload, requestConfig);
  }

  update(
    id: number,
    payload: TNewUser,
    requestConfig?: TApiHttpClientRequestConfig
  ): Promise<TUser> {
    return this.patch<TUser>(`users/${id}`, payload, requestConfig);
  }

  destroy(id: number, requestConfig?: TApiHttpClientRequestConfig): Promise<void> {
    return this.delete(`users/${id}`, undefined, requestConfig);
  }

  sendLoginEmail(id: number, requestConfig?: TApiHttpClientRequestConfig): Promise<void> {
    return this.post(`users/${id}/send-login-email`, undefined, requestConfig);
  }

  loginLink(id: number, requestConfig?: TApiHttpClientRequestConfig): Promise<TLoginLink> {
    return this.get(`users/${id}/login-link`, undefined, requestConfig);
  }

  changeSubscription(
    id: number,
    state: boolean,
    type: ESubscriptionType,
    requestConfig?: TApiHttpClientRequestConfig
  ): Promise<void> {
    return this.post(
      `users/${id}/change-subscription`,
      { state: Number(state), type },
      requestConfig
    );
  }

  suspend(id: number, requestConfig?: TApiHttpClientRequestConfig): Promise<void> {
    return this.put(`users/${id}/suspend`, undefined, requestConfig);
  }

  activate(id: number, requestConfig?: TApiHttpClientRequestConfig): Promise<void> {
    return this.put(`users/${id}/activate`, undefined, requestConfig);
  }
}
